<div class="dialog">
  <h1>
    @if (duplicates.length === 1) {
      Duplicate Filename
    } @else {
      Duplicate Filenames
    }
  </h1>
  <p>
    @if (duplicates.length === 1) {
      An asset named <b>{{ duplicates[0] }}</b> already exists. How do you want to continue?
    } @else {
      There are <b>{{ duplicates.length }} assets</b> with the same filename in this gallery. How do you want to
      continue?
    }
  </p>

  <div class="actions">
    @if (allowedActions.includes('skip')) {
      <app-radio [checkStyle]="'radio'" [checked]="action === 'skip'" (click)="action = 'skip'">
        @if (duplicates.length === 1) {
          Skip duplicate
        } @else {
          Skip duplicates
        }
      </app-radio>
    }
    @if (allowedActions.includes('override')) {
      <app-radio
        [checkStyle]="'radio'"
        [checked]="action === 'override'"
        (click)="action = 'override'"
        [flex]="true"
        data-test-id="replace"
      >
        <span>
          @if (textType === 'upload') {
            Upload and replace existing
          } @else {
            Replace existing asset
          }
        </span>
        @if ('asset-version:multiple' | billingScope: gallery) {
          <app-svg
            src="/assets/icons/16/info.svg"
            appTooltip="This creates a new asset version. You can still access all previous versions of this asset."
            size="-1"
          ></app-svg>
        }
      </app-radio>
    }

    @if (allowedActions.includes('new_assets')) {
      <app-radio [checkStyle]="'radio'" [checked]="action === 'new_assets'" (click)="action = 'new_assets'">
        @if (duplicates.length === 1) {
          @if (textType === 'upload') {
            Upload as separate asset
          } @else if (textType === 'move') {
            Move as separate asset
          } @else {
            Copy as separate asset
          }
        } @else {
          @if (textType === 'upload') {
            Upload as separate assets
          } @else if (textType === 'move') {
            Move as separate assets
          } @else {
            Copy as separate assets
          }
        }
      </app-radio>
    }
  </div>

  <button
    appButton
    name="confirm"
    location="duplicate-assets-dialog"
    color="primary"
    (click)="confirm()"
    height="4"
    size="3"
    weight="bold"
    spacing="full"
    shape="round"
    data-test-id="duplicate-confirm"
  >
    Continue
  </button>
</div>
